module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_f_leucistic.77df8465.png";